import { render, staticRenderFns } from "./PortfolioEmptyDefaultLayout.vue?vue&type=template&id=43702101&scoped=true"
import script from "./PortfolioEmptyDefaultLayout.vue?vue&type=script&lang=js"
export * from "./PortfolioEmptyDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43702101",
  null
  
)

export default component.exports